module.exports = __webpack_public_path__ + "images/cdb0492994cc33ec70fa313aa338427a-WestJet Vacations - English.png";